import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Segment layout for `/time/logs` — the tab shell's parent, so the timesheet-detail route
 * (`/time/logs/$timesheetId`) nests under it.
 *
 * Gating lives on the `/time` segment (routes/time.tsx); per-tab visibility is a separate,
 * finer-grained concern handled inside the shell (T07).
 */
export const Route = createFileRoute('/time/logs')({
  component: Outlet,
});
